import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatomoTracker } from 'ngx-matomo-client';
import { ChatbotService } from 'src/app/core/services/chatbot.service';
import { CookieService } from 'src/app/core/services/cookie.service';
import { DialogService } from 'src/app/core/services/dialog.service';

@Component({
  selector: 'vee-cookie-banner-dialog',
  templateUrl: './cookie-banner-dialog.component.html',
  styleUrls: ['./cookie-banner-dialog.component.scss'],
  standalone: false
})
export class CookieBannerDialogComponent implements OnInit {
  public open = false;
  public showChatbotMessage = false;
  public preferences = false;
  public searchfilter = false;
  public dataconsent = false;
  public google_analytics = false;
  public data_protection = false;

  constructor(
    public cookieService: CookieService,
    private readonly tracker: MatomoTracker,
    private readonly chatbotService: ChatbotService,
    private readonly dialogService: DialogService,
    private readonly cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.syncFromStoredRights();

    // Expose to window for chatbot service to access
    (window as any).cookieBannerDialog = this;
  }

  openWithChatbotMessage(): void {
    this.syncFromStoredRights();
    this.showChatbotMessage = true;
    this.open = true;
    this.dialogService.open('cookieBannerDialog');
    // Called from widget.js's native addEventListener (chatbot.service.ts), not an
    // Angular-bound template event — force a check so the panel content updates
    // even if this mutation happened outside Angular's own event/zone tracking.
    this.cdr.detectChanges();
  }

  openDialog(): void {
    this.syncFromStoredRights();
    this.showChatbotMessage = false;
    this.open = false;
    this.dialogService.open('cookieBannerDialog');
  }

  openPreferencesDialog(): void {
    this.syncFromStoredRights();
    this.showChatbotMessage = false;
    this.open = true;
    this.dialogService.open('cookieBannerDialog');
  }

  private syncFromStoredRights(): void {
    const r = this.cookieService.rights;
    if (!r) return;
    this.preferences = r.save_preferences ?? false;
    this.searchfilter = r.save_filters ?? false;
    this.dataconsent = r.data_consent ?? false;
    this.google_analytics = r.google_analytics ?? false;
    this.data_protection = r.data_protection ?? false;
  }
  accept(): void {
    this.cookieService.rights = {
      save_preferences: this.preferences,
      save_filters: this.searchfilter,
      data_consent: this.dataconsent,
      google_analytics: this.google_analytics,
      data_protection: this.data_protection,
    };
    this.cookieService.neededRightsChange = undefined;
    
    // Notify consent changes
    this.cookieService.updateChatbotConsent();
    
    this.cookieService.setJustConfirmed(true);
    
    if (this.dataconsent) {
      this.tracker.rememberConsentGiven();
      this.tracker.trackPageView();
    }
    if (this.google_analytics) {
      this.cookieService.loadGoogleTagManager();
    }
    if (this.data_protection) {
      this.chatbotService.loadChatbot();
    } else {
      this.chatbotService.unloadChatbot();
    }

    this.dialogService.close('cookieBannerDialog');
  }

  get savePreferencesNeeded() {
    return this.cookieService.neededRightsChange?.save_preferences;
  }

  acceptAll(): void {
    this.cookieService.rights = {
      save_preferences: true,
      save_filters: true,
      data_consent: true,
      google_analytics: true,
      data_protection: true
    };
    this.cookieService.neededRightsChange = undefined;
    
    // Notify consent changes
    this.cookieService.updateChatbotConsent();
    
    this.cookieService.setJustConfirmed(true);
    
    this.tracker.rememberConsentGiven();
    this.tracker.trackPageView();
    this.cookieService.loadGoogleTagManager();
    this.chatbotService.loadChatbot();

    this.dialogService.close('cookieBannerDialog');
  }
}
